import { Alert, AlertIcon, Flex, Text } from '@chakra-ui/react'
import { Dispatch, SetStateAction } from 'react'

import { baseEstablishment, IEstablishmentForm } from '../establishments/establishmentForm'
import { EstablishmentsEditor } from '../establishments/EstablishmentsEditor'
import { IEventForm } from './eventFormShared'

interface IProps {
  form: IEventForm
  setForm: Dispatch<SetStateAction<IEventForm>>
  fieldErrors: Record<string, string[]>
  setFieldErrors: Dispatch<SetStateAction<Record<string, string[]>>>
  saving: boolean
}

/** "Produtos e Serviços" do evento (ABRA-317): estabelecimentos que vendem no evento. */
export function EstablishmentsTab({ form, setForm, fieldErrors, setFieldErrors, saving }: IProps) {
  return (
    <Flex direction="column" gap={4}>
      <Text variant="caption">
        Estabelecimentos parceiros e o que eles vendem no evento. A venda é registrada no cartão do participante e
        cobrada no checkout, junto com o leilão. A taxa da ABRA sai do repasse do estabelecimento.
      </Text>

      {form.establishments.length > 0 && !form.use_nfc && (
        <Alert status="warning" borderRadius="md" fontSize="sm">
          <AlertIcon />
          Este evento não usa cartão NFC: sem ele os estabelecimentos não conseguem vender. Ative o NFC na aba Geral.
        </Alert>
      )}

      <EstablishmentsEditor<IEstablishmentForm>
        establishments={form.establishments}
        onChange={(establishments) => setForm((prev) => ({ ...prev, establishments }))}
        errorKey="establishments"
        fieldErrors={fieldErrors}
        setFieldErrors={setFieldErrors}
        saving={saving}
        createEstablishment={baseEstablishment}
      />
    </Flex>
  )
}
